import { useEffect, useRef } from "react";
import { Terminal, Trash2 } from "lucide-react";

const levelColor = {
  log: "text-zinc-300",
  info: "text-sky-400",
  warn: "text-amber-400",
  error: "text-rose-400",
};

const levelPrefix = {
  log: "›",
  info: "ℹ",
  warn: "⚠",
  error: "✖",
};

export const Console = ({ logs, onClear }) => {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ block: "end" });
  }, [logs]);

  return (
    <div className="h-44 shrink-0 flex flex-col border-t border-border bg-black">
      <div className="flex items-center gap-2 px-3 h-8 border-b border-zinc-800 shrink-0">
        <Terminal className="h-3.5 w-3.5 text-emerald-400" />
        <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-400">
          控制台
        </span>
        {logs.length > 0 && (
          <span className="text-[10px] font-mono text-zinc-600">{logs.length}</span>
        )}
        <button
          data-testid="console-clear-btn"
          onClick={onClear}
          title="清空控制台"
          className="ml-auto flex items-center gap-1 text-[10px] font-mono text-zinc-500 hover:text-zinc-200 transition-colors"
        >
          <Trash2 className="h-3 w-3" /> 清空
        </button>
      </div>
      <div
        data-testid="console-output"
        className="flex-1 overflow-y-auto px-3 py-2 font-mono text-xs leading-5"
      >
        {logs.length === 0 ? (
          <div className="text-zinc-600 select-none">// 控制台输出与错误信息将显示在这里…</div>
        ) : (
          logs.map((l, i) => (
            <div key={i} className={`flex gap-2 ${levelColor[l.level] || "text-zinc-300"}`}>
              <span className="select-none opacity-70">{levelPrefix[l.level] || "›"}</span>
              <span className="whitespace-pre-wrap break-all">{l.msg}</span>
            </div>
          ))
        )}
        <div ref={endRef} />
      </div>
    </div>
  );
};
